import { createAction, props } from '@ngrx/store';
import { IGetDirectorsPreviousResponse } from '../models/get-directors.model';

export const loadPreviousBusinessAdministrators = createAction(
  '[PreviousBusinessAdministrators] Load PreviousBusinessAdministratorss',
  props<{ request: { businessId: string; userRoleIds: string[] } }>()
);

export const loadPreviousBusinessAdministratorsSuccess = createAction(
  '[PreviousBusinessAdministrators] Load PreviousBusinessAdministratorss Success',
  props<{ response: IGetDirectorsPreviousResponse[] }>()
);

export const loadPreviousBusinessAdministratorsFailure = createAction(
  '[PreviousBusinessAdministrators] Load PreviousBusinessAdministratorss Failure',
  props<{ error: Error | any }>()
);
